export default __webpack_public_path__ + "static/media/KOD0049-min.e5588da6.webp";